import axios from 'axios'
import { cookies, logoutCookies } from './cookies'
import router from '../router/index'
import { Notification } from 'element-ui'

function reqBaseUrl() {
  const domainUrl = location.href
  let baseUrl = ''
  const staging2Regex = /(staging-2)/
  const stagingRegex = /(localhost|staging)/
  const prodRegex = /(backstage|daisuki)/

  if (staging2Regex.test(domainUrl)) {
    baseUrl = 'https://staging2.ap.gladmobile.com/'
  } else if (stagingRegex.test(domainUrl)) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (prodRegex.test(domainUrl)) {
    baseUrl = 'https://test-fleet.gladmobile.com/'
  } else {
    baseUrl = 'https://' + window.location.hostname + '/'
  }
  return baseUrl + 'web/api/'
}

function reqEnterpriseBaseUrl() {
  const domainUrl = location.href
  let baseUrl = ''
  const staging2Regex = /(staging-2)/
  const stagingRegex = /(localhost|staging)/
  const prodRegex = /(backstage|daisuki)/

  if (staging2Regex.test(domainUrl)) {
    baseUrl = 'https://staging2.ap.gladmobile.com/'
  } else if (stagingRegex.test(domainUrl)) {
    baseUrl = 'https://staging.ap.gladmobile.com/'
  } else if (prodRegex.test(domainUrl)) {
    baseUrl = 'https://test-fleet.gladmobile.com/'
  } else {
    baseUrl = 'https://' + window.location.hostname + '/'
  }
  return baseUrl + 'enterprise/api/web/'
}
function reqDownloadBaseUrl() {
  const domainUrl = location.href
  let baseUrl = ''
  const stagingRegex = /(localhost|staging)/
  const prodRegex = /(backstage)/

  if (stagingRegex.test(domainUrl)) {
    baseUrl = 'https://staging.download.gladmobile.com/'
  } else if (prodRegex.test(domainUrl)) {
    baseUrl = 'https://download.gladmobile.com/'
  }
  return baseUrl + 'web/api/'
}

function errorHandler(e) {
  if (
    e.response &&
    e.response.data.message === 'jwt expired' &&
    cookies.get('user')
  ) {
    Notification({
      title: `請重新登入`,
      message: `您的登入資訊已過期，請重新登入，以確保資料的正確性。`,
      type: 'warning',
      position: 'top-right',
      duration: 0,
    })
    request.defaults.headers.common['x-access-token'] = undefined
    logoutCookies()
    setTimeout(() => {
      /* 需要區分是從網頁後台進入或是派車軟體小橘進入 */
      if (router.currentRoute.query.from === 'desktop') {
        router.replace({ name: 'ServiceLogin' })
      } else {
        router.replace({ name: 'Login' })
      }
    }, 3 * 1000)
  } else if (e.response && e.response.status >= 500) {
    Notification({
      title: `伺服器發生錯誤`,
      message: `伺服器發生錯誤，請聯絡管理人員`,
      type: 'warning',
    })
  } else if (e.code === 'ECONNABORTED') {
    console.warn(
      'api請求逾時，可能是response超過timeout的時間或是後端伺服器發生問題',
    )
  }
  if (e.response) {
    return Promise.reject(e.response.data)
  } else {
    /* 處理取消請求 */
    return Promise.reject({ isCancel: true })
  }
}

/* 正常的請求 timout=5s */
const request = axios.create({
  baseURL: reqBaseUrl(),
  /* timeout: 1000 * 5, */
  /* 因為此請求而調整timout時間 => GET https://staging.ap.gladmobile.com/web/api/service/address/near?points=120.21013,22.969935 */
  timeout: 1000 * 8,
})

request.defaults.headers.common['x-access-token'] = cookies.get('user')
request.interceptors.response.use((res) => res.data, errorHandler)

/* 企業的請求 timout=5s */
const enterpriseRequest = axios.create({
  baseURL: reqEnterpriseBaseUrl(),
  timeout: 1000 * 5,
})

enterpriseRequest.defaults.headers.common['x-access-token'] =
  cookies.get('user')
enterpriseRequest.interceptors.response.use((res) => res.data, errorHandler)

/* 叫車的請求 timout=65s */
const hailRequest = axios.create({
  baseURL: reqBaseUrl(),
  timeout: 1000 * 65,
})

hailRequest.defaults.headers.common['x-access-token'] = cookies.get('user')
hailRequest.interceptors.response.use((res) => res.data, errorHandler)

/* firebase請求 timeout=5s */
const firebaseRequest = axios.create({
  baseURL: 'https://us-central1-backstage-web-e5597.cloudfunctions.net/',
  timeout: 1000 * 5,
})

firebaseRequest.defaults.headers.common['x-access-token'] = cookies.get('user')
firebaseRequest.interceptors.response.use((res) => res.data, errorHandler)

/* download請求 timeout=5s */
const downloadRequest = axios.create({
  baseURL: reqDownloadBaseUrl(),
  timeout: 1000 * 5,
})

downloadRequest.defaults.headers.common['x-access-token'] = cookies.get('user')
downloadRequest.defaults.responseType = 'blob'
downloadRequest.interceptors.response.use((res) => res.data, errorHandler)

export {
  reqBaseUrl,
  request,
  hailRequest,
  firebaseRequest,
  downloadRequest,
  enterpriseRequest,
}



// WEBPACK FOOTER //
// ./src/utils/request.js